import { useEffect, useState } from 'react';

const STORAGE_KEY = 'authQueryParams';

export const useQueryParams = () => {
    const [queryParams, setQueryParams] = useState<{ 
        personId?: string;
        contactId?: string;
        permissionsList?: string[];
    }>({});

    useEffect(() => {
        // First, try to restore from sessionStorage
        const savedParams = sessionStorage.getItem(STORAGE_KEY);
        if (savedParams) {
            const params = new URLSearchParams(savedParams);
            const restored = {
                personId: params.get('personId') || undefined,
                contactId: params.get('contactId') || undefined,
                permissionsList: params.get('permissionsList')?.split(',') || [],
            };
            
            // Update URL with restored params
            const url = new URL(window.location.href);
            url.search = savedParams;
            window.history.replaceState({}, '', url);
            
            // Clean up storage
            sessionStorage.removeItem(STORAGE_KEY);
            
            setQueryParams(restored);
            return;
        }

        // Otherwise, read from current URL
        const params = new URLSearchParams(window.location.search);
        setQueryParams({
            personId: params.get('personId') || undefined,
            contactId: params.get('contactId') || undefined,
            permissionsList: params.get('permissionsList')?.split(',') || [],
        });
    }, []);

    return queryParams;
};

export const preserveQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.toString()) {
        sessionStorage.setItem(STORAGE_KEY, params.toString());
    }
};
